import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from '@mds/angular-core';
import { LayoutComponent } from '@mds/angular-layout-primeng';
import { LocalUserGuard, ReAuthenticationGuard } from './shared';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'home',
        loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
        canActivate: [authGuard],
      },
      {
        path: 'account',
        children: [
          {
            path: 'email',
            loadChildren: () => import('./account/email/email.module').then((m) => m.EmailModule),
          },
          {
            path: 'register',
            loadChildren: () => import('./account/register/register.module').then((m) => m.RegisterModule),
          },
          {
            path: 'data-protection',
            loadChildren: () =>
              import('./account/data-protection/data-protection.module').then((m) => m.DataProtectionModule),
          },
        ],
      },
      {
        path: 'security',
        children: [
          {
            path: 'password',
            loadChildren: () => import('./security/password/password.module').then((m) => m.PasswordModule),
          },
          {
            path: 'mfa',
            loadChildren: () => import('./security/mfa/mfa.module').then((m) => m.MfaModule),
            canActivate: [authGuard, LocalUserGuard, ReAuthenticationGuard],
          },
        ],
      },
      {
        path: 'errors',
        loadChildren: () => import('./error/error.module').then((m) => m.ErrorModule),
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'errors/404',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
      canceledNavigationResolution: 'computed',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
